import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IFindCourseByIdDTO } from './moodle.dto';

@Injectable({
  providedIn: 'root',
})
export class MoodleApi {
  private readonly apiUrl: string = environment.apiUrl;

  constructor(private readonly http: HttpClient) {}

  getCourseById(moodleId: number): Observable<IFindCourseByIdDTO> {
    return this.http
      .get<IFindCourseByIdDTO[]>(this.apiUrl + `/moodle/course/${moodleId}`)
      .pipe(map((response) => response[0]));
  }
}
